import React from 'react';
// import React, { useState } from "react";
// import { Button, Modal } from "react-bootstrap";
// import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AiOutlineSafetyCertificate } from 'react-icons/ai';

function Experience() {
	// const [show1, setShow1] = useState(false);
	// const [show2, setShow2] = useState(false);
	// const [show3, setShow3] = useState(false);

	// const expbtn1 = () => {
	//   setShow1(true);
	// };
	// const expbtn2 = () => {
	//   setShow2(true);
	// };
	// const expbtn3 = () => {
	//   setShow3(true);
	// };
	// const expcertificate1 = () => {
	//   // using Java Script method to get PDF file
	//   fetch("FuturaLabs.pdf").then((response) => {
	//     response.blob().then((blob) => {
	//       // Creating new object of PDF file
	//       const fileURL = window.URL.createObjectURL(blob);
	//       // Setting various property values
	//       let alink = document.createElement("a");
	//       alink.href = fileURL;
	//       alink.download = "FuturaLabs.pdf";
	//       alink.click();
	//     });
	//   });
	//   setShow1(false);
	// };
	// const expcertificate2 = () => {
	//   // using Java Script method to get PDF file
	//   fetch("SilverHost-Digital-Solutions.pdf").then((response) => {
	//     response.blob().then((blob) => {
	//       // Creating new object of PDF file
	//       const fileURL = window.URL.createObjectURL(blob);
	//       // Setting various property values
	//       let alink = document.createElement("a");
	//       alink.href = fileURL;
	//       alink.download = "SilverHost-Digital-Solutions.pdf";
	//       alink.click();
	//     });
	//   });
	//   setShow2(false);
	// };
	// const expcertificate3 = () => {
	//   // using Java Script method to get PDF file
	//   fetch("SilverHost-Digital-Solutions.pdf").then((response) => {
	//     response.blob().then((blob) => {
	//       // Creating new object of PDF file
	//       const fileURL = window.URL.createObjectURL(blob);
	//       // Setting various property values
	//       let alink = document.createElement("a");
	//       alink.href = fileURL;
	//       alink.download = "SilverHost-Digital-Solutions.pdf";
	//       alink.click();
	//     });
	//   });
	//   setShow3(false);
	// };
	return (
		<>
			<h2 className="sec-head">Experience</h2>
			<h4 className="exp-role">
				Front-end Developer
				<span className="ms-2">
					{/* <OverlayTrigger
            placement="bottom"
            delay={{ show: 200, hide: 250 }}
            overlay={
              <Tooltip className="exp-trig">
                Download experience certificate
              </Tooltip>
            }
          > */}
					{/* <button className="exp-btn btn" onClick={expbtn3}> */}
					<button className="exp-btn btn">
						<AiOutlineSafetyCertificate />
					</button>
					{/* </OverlayTrigger> */}
				</span>
			</h4>
			<p className="para-mar">
				Mykare Health, Kochi, Kerala, India
				<br />
				May 2023 - Dec 2023
			</p>
			<h4 className="exp-role">
				Full Stack Developer
				<span className="ms-2">
					{/* <OverlayTrigger
            placement="bottom"
            delay={{ show: 200, hide: 250 }}
            overlay={
              <Tooltip className="exp-trig">
                Download experience certificate
              </Tooltip>
            }
          > */}
					{/* <button className="exp-btn btn" onClick={expbtn1}> */}
					<button className="exp-btn btn">
						<AiOutlineSafetyCertificate />
					</button>
					{/* </OverlayTrigger> */}
				</span>
			</h4>
			<p className="para-mar">
				Futura Labs Technologies LLP, Calicut, Kerala, India
				<br />
				Dec 2022 - April 2023
			</p>
			<h4 className="exp-role">
				Front-end Developer
				<span className="ms-2">
					{/* <OverlayTrigger
            placement="bottom"
            delay={{ show: 200, hide: 250 }}
            overlay={
              <Tooltip className="exp-trig">
                Download experience certificate
              </Tooltip>
            }
          > */}
					{/* <button className="exp-btn btn" onClick={expbtn2}> */}
					<button className="exp-btn btn">
						<AiOutlineSafetyCertificate />
					</button>
					{/* </OverlayTrigger> */}
				</span>
			</h4>
			<p className="para-mar">
				SilverHost Web Solution, Palakkad, Kerala, India
				<br />
				jan 2022 - Nov 2022
			</p>
			{/* <Modal show={show1} centered>
        <Modal.Body>
          <h5 className="text-dark" style={{ fontWeight: "400" }}>
            To download the experience certificate, simply click the "Confirm" button.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShow1(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={expcertificate1}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} centered>
        <Modal.Body>
          <h5 className="text-dark" style={{ fontWeight: "400" }}>
            To download the experience certificate, simply click the "Confirm" button.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShow2(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={expcertificate2}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show3} centered>
        <Modal.Body>
          <h5 className="text-dark" style={{ fontWeight: "400" }}>
            To download the experience certificate, simply click the "Confirm" button.
          </h5>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              setShow3(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="success" onClick={expcertificate3}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal> */}
		</>
	);
}

export default Experience;
